import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import {
  BORDER,
  COLOR_BLACK_10,
  COLOR_GREY_6,
  COLOR_PRIMARY_BACKGROUND,
  COLOR_WHITE,
} from "shared/theme/colors";
import { border, flex } from "shared/theme/mixins";

export const StyledGameInformationContainer = styled(Box)`
  ${flex({ fd: "column" })};
  ${border(1, COLOR_GREY_6)};
  gap: 0.5rem;
  border-radius: 0.75rem;
  padding: 1rem;
`;

export const StyledMetadataTabs = styled(Box)`
  ${flex({ fd: "row" })};
  width: fit-content;
  ${border(1, COLOR_BLACK_10)};
  border-radius: 8px;
`;

export const StyledMetadataTab = styled(Box, {
  shouldForwardProp: (props) => props !== "isActive",
})<{ isActive?: boolean }>`
  ${flex({ fd: "row" })};
  padding: 0.5rem 1rem;
  cursor: pointer;
  background-color: ${({ isActive }) =>
    isActive ? COLOR_PRIMARY_BACKGROUND : COLOR_WHITE};

  &:not(:last-of-type) {
    border-right: ${BORDER(1, COLOR_BLACK_10)};
  }

  &:first-of-type {
    border-radius: 8px 0 0 8px;
  }
  &:last-of-type {
    border-radius: 0 8px 8px 0;
  }
`;
